//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import firebase from 'firebase/app'

import SelectOptions from '@/components/SelectOptions.vue'
import Skeleton from '@/components/WalletsSkeleton.vue'
export default {
	name: 'wallets',
	data: () => ({
		loadingWallet: null,
		loading: true,
		sortDepositStatus: 'ENABLE',
		sorWithdrawStatus: 'ENABLE',
		exchange: 'BINANCE',
		exchanges: ['BINANCE', 'KUCOIN', 'HUOBI', 'BITHUMB'],
		filter: '',
		wallets: [],
		data: [],
		favoritesWallets: [],
		favList: [],
	}),
	components: {
		Skeleton,
		SelectOptions,
	},

	computed: {
		...mapGetters(['getWalletsFavs']),

		exchangeWalletsFavorites() {
			const found = this.getWalletsFavs.find(
				(el) => el.exchange.toUpperCase() === this.exchange.toUpperCase()
			)
			return found ? found.favorites : []
		},
		getDataParams() {
			return {
				exchange: this.exchange,
			}
		},

		filteredWallets() {
			try {
				return this.wallets.filter((el) => {
					return el.coin.toLowerCase().match(this.filter.toLowerCase())
				})
			} catch (e) {
				return this.wallets
			}
		},
	},
	watch: {
		getDataParams(val) {
			if (val) {
				const { exchange } = val
				this.fetchData(exchange)
			}
		},
	},

	async created() {
		await this.fetchData(this.exchange, this.wallets)
	},

	methods: {
		...mapActions(['getWallets', 'addToWalletsFavs', 'deleteFromWalletsFavs']),

		async addToExchangeFavs(t) {
			const name = t.coin
			this.loadingWallet = name
			const currentUser = firebase.auth().currentUser
			if (currentUser) {
				await this.addToWalletsFavs({
					exchange: this.exchange.toUpperCase(),
					wallet: { name },
				})
			} else {
				this.$router.push('/login')
			}
			this.loadingWallet = null
		},
		async deleteFromExchangeFavs(ticker) {
			const { id, name } = this.exchangeWalletsFavorites.find(
				(val) => val.name === ticker.coin
			)
			this.loadingWallet = name
			await this.deleteFromWalletsFavs({
				id,
				exchange: this.exchange,
			})
			this.loadingWallet = null
		},
		async refresh() {
			await this.fetchData(this.exchange, this.wallets)
		},

		async fetchData(exchange) {
			try {
				this.loading = true
				const { length, wallets } = await this.getWallets({
					exchange,
				})
				this.wallets = wallets
				this.loading = false
			} catch (e) {
				this.loading = false
				console.warn('Error while executing', e)
			}
		},
		selectExchange(exchange) {
			this.exchange = exchange
		},
	},
}
